import { PAYMENTS } from '@shared/contants/payments'
import { cn } from '@shared/lib/cn'

import styles from './styles.module.scss'

interface PaymentSystemsProps {
  className?: string;
}

export default function PaymentSystems (props: PaymentSystemsProps) {
  const { className } = props

  return (
    <div className={cn(styles.root, className)}>
      {PAYMENTS.items.map((item, index) => {
        return (
          <div className={styles.root__item} key={index}>
            <img
              src={item.icon}
              alt={item.title}
              loading="lazy"
              fetchPriority="low"
            />
          </div>
        )
      })}
    </div>
  )
}
